export default __webpack_public_path__ + "static/media/shinhancard.c056208a.png";